import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import '@babel/polyfill' を置き換える
// see http://var.blog.jp/archives/79457227.html
// import 'core-js/stable'
// import 'regenerator-runtime/runtime'
// → polyfillはbabel.config.js と htmlのpolyfill.ioで設定する

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
